export default __webpack_public_path__ + "static/media/fuelEnDetailTruckTablet.f2a11384.jpg";